var _clipPath, _clipPath2, _clipPath3, _clipPath4, _g, _g2, _g3, _g4, _g5, _g6, _clipPath5, _clipPath6, _g7, _g8, _g9, _g10, _g11, _g12, _clipPath7, _clipPath8, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBaloise(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2500 550",
    width: 2500,
    height: 550,
    preserveAspectRatio: "xMidYMid meet",
    style: {
      width: "100%",
      height: "100%",
      transform: "translate3d(0px, 0px, 0px)",
      contentVisibility: "visible"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "__lottie_element_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2500,
    height: 550,
    x: 0,
    y: 0
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "__lottie_element_4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2560,0 L2560,2560 L0,2560z"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "__lottie_element_7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2560,0 L2560,2560 L0,2560z"
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "__lottie_element_10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2560,0 L2560,2560 L0,2560z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "__lottie_element_13",
    "mask-type": "alpha"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "block"
    },
    transform: "matrix(7.806458950042725,7.806458950042725,-7.806458950042725,7.806458950042725,2236.77587890625,-6332.1552734375)",
    opacity: 1
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,426.4100036621094,548.8280029296875)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(21,31,109)",
    fillOpacity: 1,
    d: " M130.11300659179688,8.111000061035156 C134.5919952392578,3.631999969482422 134.5919952392578,-3.63100004196167 130.11300659179688,-8.109999656677246 C130.11300659179688,-8.109999656677246 8.109999656677246,-130.11199951171875 8.109999656677246,-130.11199951171875 C3.63100004196167,-134.5919952392578 -3.63100004196167,-134.5919952392578 -8.109999656677246,-130.11199951171875 C-8.109999656677246,-130.11199951171875 -130.11300659179688,-8.109999656677246 -130.11300659179688,-8.109999656677246 C-134.5919952392578,-3.63100004196167 -134.5919952392578,3.631999969482422 -130.11300659179688,8.111000061035156 C-130.11300659179688,8.111000061035156 -8.109999656677246,130.11300659179688 -8.109999656677246,130.11300659179688 C-3.63100004196167,134.59300231933594 3.63100004196167,134.59300231933594 8.109999656677246,130.11300659179688 C8.109999656677246,130.11300659179688 130.11300659179688,8.111000061035156 130.11300659179688,8.111000061035156z"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "__lottie_element_17",
    "mask-type": "alpha"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "block"
    },
    transform: "matrix(7.806458950042725,7.806458950042725,-7.806458950042725,7.806458950042725,2236.77587890625,-6332.1552734375)",
    opacity: 1
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,426.4100036621094,548.8280029296875)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(21,31,109)",
    fillOpacity: 1,
    d: " M130.11300659179688,8.111000061035156 C134.5919952392578,3.631999969482422 134.5919952392578,-3.63100004196167 130.11300659179688,-8.109999656677246 C130.11300659179688,-8.109999656677246 8.109999656677246,-130.11199951171875 8.109999656677246,-130.11199951171875 C3.63100004196167,-134.5919952392578 -3.63100004196167,-134.5919952392578 -8.109999656677246,-130.11199951171875 C-8.109999656677246,-130.11199951171875 -130.11300659179688,-8.109999656677246 -130.11300659179688,-8.109999656677246 C-134.5919952392578,-3.63100004196167 -134.5919952392578,3.631999969482422 -130.11300659179688,8.111000061035156 C-130.11300659179688,8.111000061035156 -8.109999656677246,130.11300659179688 -8.109999656677246,130.11300659179688 C-3.63100004196167,134.59300231933594 3.63100004196167,134.59300231933594 8.109999656677246,130.11300659179688 C8.109999656677246,130.11300659179688 130.11300659179688,8.111000061035156 130.11300659179688,8.111000061035156z"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "__lottie_element_21",
    "mask-type": "alpha"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "block"
    },
    transform: "matrix(7.806458950042725,7.806458950042725,-7.806458950042725,7.806458950042725,2236.77587890625,-6332.1552734375)",
    opacity: 1
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,426.4100036621094,548.8280029296875)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(21,31,109)",
    fillOpacity: 1,
    d: " M130.11300659179688,8.111000061035156 C134.5919952392578,3.631999969482422 134.5919952392578,-3.63100004196167 130.11300659179688,-8.109999656677246 C130.11300659179688,-8.109999656677246 8.109999656677246,-130.11199951171875 8.109999656677246,-130.11199951171875 C3.63100004196167,-134.5919952392578 -3.63100004196167,-134.5919952392578 -8.109999656677246,-130.11199951171875 C-8.109999656677246,-130.11199951171875 -130.11300659179688,-8.109999656677246 -130.11300659179688,-8.109999656677246 C-134.5919952392578,-3.63100004196167 -134.5919952392578,3.631999969482422 -130.11300659179688,8.111000061035156 C-130.11300659179688,8.111000061035156 -8.109999656677246,130.11300659179688 -8.109999656677246,130.11300659179688 C-3.63100004196167,134.59300231933594 3.63100004196167,134.59300231933594 8.109999656677246,130.11300659179688 C8.109999656677246,130.11300659179688 130.11300659179688,8.111000061035156 130.11300659179688,8.111000061035156z"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "__lottie_element_29",
    "mask-type": "alpha"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "block"
    },
    transform: "matrix(7.806458950042725,7.806458950042725,-7.806458950042725,7.806458950042725,2388.77587890625,-6332.1552734375)",
    opacity: 1
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,426.4100036621094,548.8280029296875)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(21,31,109)",
    fillOpacity: 1,
    d: " M130.11300659179688,8.111000061035156 C134.5919952392578,3.631999969482422 134.5919952392578,-3.63100004196167 130.11300659179688,-8.109999656677246 C130.11300659179688,-8.109999656677246 8.109999656677246,-130.11199951171875 8.109999656677246,-130.11199951171875 C3.63100004196167,-134.5919952392578 -3.63100004196167,-134.5919952392578 -8.109999656677246,-130.11199951171875 C-8.109999656677246,-130.11199951171875 -130.11300659179688,-8.109999656677246 -130.11300659179688,-8.109999656677246 C-134.5919952392578,-3.63100004196167 -134.5919952392578,3.631999969482422 -130.11300659179688,8.111000061035156 C-130.11300659179688,8.111000061035156 -8.109999656677246,130.11300659179688 -8.109999656677246,130.11300659179688 C-3.63100004196167,134.59300231933594 3.63100004196167,134.59300231933594 8.109999656677246,130.11300659179688 C8.109999656677246,130.11300659179688 130.11300659179688,8.111000061035156 130.11300659179688,8.111000061035156z"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "__lottie_element_33",
    "mask-type": "alpha"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "block"
    },
    transform: "matrix(7.806458950042725,7.806458950042725,-7.806458950042725,7.806458950042725,2236.77587890625,-6332.1552734375)",
    opacity: 1
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,426.4100036621094,548.8280029296875)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(21,31,109)",
    fillOpacity: 1,
    d: " M130.11300659179688,8.111000061035156 C134.5919952392578,3.631999969482422 134.5919952392578,-3.63100004196167 130.11300659179688,-8.109999656677246 C130.11300659179688,-8.109999656677246 8.109999656677246,-130.11199951171875 8.109999656677246,-130.11199951171875 C3.63100004196167,-134.5919952392578 -3.63100004196167,-134.5919952392578 -8.109999656677246,-130.11199951171875 C-8.109999656677246,-130.11199951171875 -130.11300659179688,-8.109999656677246 -130.11300659179688,-8.109999656677246 C-134.5919952392578,-3.63100004196167 -134.5919952392578,3.631999969482422 -130.11300659179688,8.111000061035156 C-130.11300659179688,8.111000061035156 -8.109999656677246,130.11300659179688 -8.109999656677246,130.11300659179688 C-3.63100004196167,134.59300231933594 3.63100004196167,134.59300231933594 8.109999656677246,130.11300659179688 C8.109999656677246,130.11300659179688 130.11300659179688,8.111000061035156 130.11300659179688,8.111000061035156z"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "__lottie_element_37",
    "mask-type": "alpha"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "block"
    },
    transform: "matrix(7.806458950042725,7.806458950042725,-7.806458950042725,7.806458950042725,2236.77587890625,-6332.1552734375)",
    opacity: 1
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,426.4100036621094,548.8280029296875)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(21,31,109)",
    fillOpacity: 1,
    d: " M130.11300659179688,8.111000061035156 C134.5919952392578,3.631999969482422 134.5919952392578,-3.63100004196167 130.11300659179688,-8.109999656677246 C130.11300659179688,-8.109999656677246 8.109999656677246,-130.11199951171875 8.109999656677246,-130.11199951171875 C3.63100004196167,-134.5919952392578 -3.63100004196167,-134.5919952392578 -8.109999656677246,-130.11199951171875 C-8.109999656677246,-130.11199951171875 -130.11300659179688,-8.109999656677246 -130.11300659179688,-8.109999656677246 C-134.5919952392578,-3.63100004196167 -134.5919952392578,3.631999969482422 -130.11300659179688,8.111000061035156 C-130.11300659179688,8.111000061035156 -8.109999656677246,130.11300659179688 -8.109999656677246,130.11300659179688 C-3.63100004196167,134.59300231933594 3.63100004196167,134.59300231933594 8.109999656677246,130.11300659179688 C8.109999656677246,130.11300659179688 130.11300659179688,8.111000061035156 130.11300659179688,8.111000061035156z"
  }))))), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "__lottie_element_46"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2560,0 L2560,2560 L0,2560z"
  }))), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "__lottie_element_49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2560,0 L2560,2560 L0,2560z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "__lottie_element_52",
    "mask-type": "alpha"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "block"
    },
    transform: "matrix(7.806458950042725,7.806458950042725,-7.806458950042725,7.806458950042725,2236.77587890625,-6332.1552734375)",
    opacity: 1
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,426.4100036621094,548.8280029296875)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(21,31,109)",
    fillOpacity: 1,
    d: " M130.11300659179688,8.111000061035156 C134.5919952392578,3.631999969482422 134.5919952392578,-3.63100004196167 130.11300659179688,-8.109999656677246 C130.11300659179688,-8.109999656677246 8.109999656677246,-130.11199951171875 8.109999656677246,-130.11199951171875 C3.63100004196167,-134.5919952392578 -3.63100004196167,-134.5919952392578 -8.109999656677246,-130.11199951171875 C-8.109999656677246,-130.11199951171875 -130.11300659179688,-8.109999656677246 -130.11300659179688,-8.109999656677246 C-134.5919952392578,-3.63100004196167 -134.5919952392578,3.631999969482422 -130.11300659179688,8.111000061035156 C-130.11300659179688,8.111000061035156 -8.109999656677246,130.11300659179688 -8.109999656677246,130.11300659179688 C-3.63100004196167,134.59300231933594 3.63100004196167,134.59300231933594 8.109999656677246,130.11300659179688 C8.109999656677246,130.11300659179688 130.11300659179688,8.111000061035156 130.11300659179688,8.111000061035156z"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "__lottie_element_56",
    "mask-type": "alpha"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "block"
    },
    transform: "matrix(7.806458950042725,7.806458950042725,-7.806458950042725,7.806458950042725,2236.77587890625,-6332.1552734375)",
    opacity: 1
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,426.4100036621094,548.8280029296875)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(21,31,109)",
    fillOpacity: 1,
    d: " M130.11300659179688,8.111000061035156 C134.5919952392578,3.631999969482422 134.5919952392578,-3.63100004196167 130.11300659179688,-8.109999656677246 C130.11300659179688,-8.109999656677246 8.109999656677246,-130.11199951171875 8.109999656677246,-130.11199951171875 C3.63100004196167,-134.5919952392578 -3.63100004196167,-134.5919952392578 -8.109999656677246,-130.11199951171875 C-8.109999656677246,-130.11199951171875 -130.11300659179688,-8.109999656677246 -130.11300659179688,-8.109999656677246 C-134.5919952392578,-3.63100004196167 -134.5919952392578,3.631999969482422 -130.11300659179688,8.111000061035156 C-130.11300659179688,8.111000061035156 -8.109999656677246,130.11300659179688 -8.109999656677246,130.11300659179688 C-3.63100004196167,134.59300231933594 3.63100004196167,134.59300231933594 8.109999656677246,130.11300659179688 C8.109999656677246,130.11300659179688 130.11300659179688,8.111000061035156 130.11300659179688,8.111000061035156z"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "__lottie_element_60",
    "mask-type": "alpha"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "block"
    },
    transform: "matrix(7.806458950042725,7.806458950042725,-7.806458950042725,7.806458950042725,2236.77587890625,-6332.1552734375)",
    opacity: 1
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,426.4100036621094,548.8280029296875)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(21,31,109)",
    fillOpacity: 1,
    d: " M130.11300659179688,8.111000061035156 C134.5919952392578,3.631999969482422 134.5919952392578,-3.63100004196167 130.11300659179688,-8.109999656677246 C130.11300659179688,-8.109999656677246 8.109999656677246,-130.11199951171875 8.109999656677246,-130.11199951171875 C3.63100004196167,-134.5919952392578 -3.63100004196167,-134.5919952392578 -8.109999656677246,-130.11199951171875 C-8.109999656677246,-130.11199951171875 -130.11300659179688,-8.109999656677246 -130.11300659179688,-8.109999656677246 C-134.5919952392578,-3.63100004196167 -134.5919952392578,3.631999969482422 -130.11300659179688,8.111000061035156 C-130.11300659179688,8.111000061035156 -8.109999656677246,130.11300659179688 -8.109999656677246,130.11300659179688 C-3.63100004196167,134.59300231933594 3.63100004196167,134.59300231933594 8.109999656677246,130.11300659179688 C8.109999656677246,130.11300659179688 130.11300659179688,8.111000061035156 130.11300659179688,8.111000061035156z"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "__lottie_element_68",
    "mask-type": "alpha"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "block"
    },
    transform: "matrix(7.806458950042725,7.806458950042725,-7.806458950042725,7.806458950042725,2388.77587890625,-6332.1552734375)",
    opacity: 1
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,426.4100036621094,548.8280029296875)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(21,31,109)",
    fillOpacity: 1,
    d: " M130.11300659179688,8.111000061035156 C134.5919952392578,3.631999969482422 134.5919952392578,-3.63100004196167 130.11300659179688,-8.109999656677246 C130.11300659179688,-8.109999656677246 8.109999656677246,-130.11199951171875 8.109999656677246,-130.11199951171875 C3.63100004196167,-134.5919952392578 -3.63100004196167,-134.5919952392578 -8.109999656677246,-130.11199951171875 C-8.109999656677246,-130.11199951171875 -130.11300659179688,-8.109999656677246 -130.11300659179688,-8.109999656677246 C-134.5919952392578,-3.63100004196167 -134.5919952392578,3.631999969482422 -130.11300659179688,8.111000061035156 C-130.11300659179688,8.111000061035156 -8.109999656677246,130.11300659179688 -8.109999656677246,130.11300659179688 C-3.63100004196167,134.59300231933594 3.63100004196167,134.59300231933594 8.109999656677246,130.11300659179688 C8.109999656677246,130.11300659179688 130.11300659179688,8.111000061035156 130.11300659179688,8.111000061035156z"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "__lottie_element_72",
    "mask-type": "alpha"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "block"
    },
    transform: "matrix(7.806458950042725,7.806458950042725,-7.806458950042725,7.806458950042725,2236.77587890625,-6332.1552734375)",
    opacity: 1
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,426.4100036621094,548.8280029296875)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(21,31,109)",
    fillOpacity: 1,
    d: " M130.11300659179688,8.111000061035156 C134.5919952392578,3.631999969482422 134.5919952392578,-3.63100004196167 130.11300659179688,-8.109999656677246 C130.11300659179688,-8.109999656677246 8.109999656677246,-130.11199951171875 8.109999656677246,-130.11199951171875 C3.63100004196167,-134.5919952392578 -3.63100004196167,-134.5919952392578 -8.109999656677246,-130.11199951171875 C-8.109999656677246,-130.11199951171875 -130.11300659179688,-8.109999656677246 -130.11300659179688,-8.109999656677246 C-134.5919952392578,-3.63100004196167 -134.5919952392578,3.631999969482422 -130.11300659179688,8.111000061035156 C-130.11300659179688,8.111000061035156 -8.109999656677246,130.11300659179688 -8.109999656677246,130.11300659179688 C-3.63100004196167,134.59300231933594 3.63100004196167,134.59300231933594 8.109999656677246,130.11300659179688 C8.109999656677246,130.11300659179688 130.11300659179688,8.111000061035156 130.11300659179688,8.111000061035156z"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "__lottie_element_76",
    "mask-type": "alpha"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "block"
    },
    transform: "matrix(7.806458950042725,7.806458950042725,-7.806458950042725,7.806458950042725,2236.77587890625,-6332.1552734375)",
    opacity: 1
  }, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,426.4100036621094,548.8280029296875)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(21,31,109)",
    fillOpacity: 1,
    d: " M130.11300659179688,8.111000061035156 C134.5919952392578,3.631999969482422 134.5919952392578,-3.63100004196167 130.11300659179688,-8.109999656677246 C130.11300659179688,-8.109999656677246 8.109999656677246,-130.11199951171875 8.109999656677246,-130.11199951171875 C3.63100004196167,-134.5919952392578 -3.63100004196167,-134.5919952392578 -8.109999656677246,-130.11199951171875 C-8.109999656677246,-130.11199951171875 -130.11300659179688,-8.109999656677246 -130.11300659179688,-8.109999656677246 C-134.5919952392578,-3.63100004196167 -134.5919952392578,3.631999969482422 -130.11300659179688,8.111000061035156 C-130.11300659179688,8.111000061035156 -8.109999656677246,130.11300659179688 -8.109999656677246,130.11300659179688 C-3.63100004196167,134.59300231933594 3.63100004196167,134.59300231933594 8.109999656677246,130.11300659179688 C8.109999656677246,130.11300659179688 130.11300659179688,8.111000061035156 130.11300659179688,8.111000061035156z"
  }))))), _clipPath7 || (_clipPath7 = /*#__PURE__*/React.createElement("clipPath", {
    id: "__lottie_element_85"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2560,0 L2560,2560 L0,2560z"
  }))), _clipPath8 || (_clipPath8 = /*#__PURE__*/React.createElement("clipPath", {
    id: "__lottie_element_88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2560,0 L2560,2560 L0,2560z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "__lottie_element_91",
    "mask-type": "alpha"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "block"
    },
    transform: "matrix(7.806458950042725,7.806458950042725,-7.806458950042725,7.806458950042725,2236.77587890625,-6332.1552734375)",
    opacity: 1
  }, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,426.4100036621094,548.8280029296875)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(21,31,109)",
    fillOpacity: 1,
    d: " M130.11300659179688,8.111000061035156 C134.5919952392578,3.631999969482422 134.5919952392578,-3.63100004196167 130.11300659179688,-8.109999656677246 C130.11300659179688,-8.109999656677246 8.109999656677246,-130.11199951171875 8.109999656677246,-130.11199951171875 C3.63100004196167,-134.5919952392578 -3.63100004196167,-134.5919952392578 -8.109999656677246,-130.11199951171875 C-8.109999656677246,-130.11199951171875 -130.11300659179688,-8.109999656677246 -130.11300659179688,-8.109999656677246 C-134.5919952392578,-3.63100004196167 -134.5919952392578,3.631999969482422 -130.11300659179688,8.111000061035156 C-130.11300659179688,8.111000061035156 -8.109999656677246,130.11300659179688 -8.109999656677246,130.11300659179688 C-3.63100004196167,134.59300231933594 3.63100004196167,134.59300231933594 8.109999656677246,130.11300659179688 C8.109999656677246,130.11300659179688 130.11300659179688,8.111000061035156 130.11300659179688,8.111000061035156z"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "__lottie_element_95",
    "mask-type": "alpha"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "block"
    },
    transform: "matrix(7.806458950042725,7.806458950042725,-7.806458950042725,7.806458950042725,2236.77587890625,-6332.1552734375)",
    opacity: 1
  }, _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,426.4100036621094,548.8280029296875)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(21,31,109)",
    fillOpacity: 1,
    d: " M130.11300659179688,8.111000061035156 C134.5919952392578,3.631999969482422 134.5919952392578,-3.63100004196167 130.11300659179688,-8.109999656677246 C130.11300659179688,-8.109999656677246 8.109999656677246,-130.11199951171875 8.109999656677246,-130.11199951171875 C3.63100004196167,-134.5919952392578 -3.63100004196167,-134.5919952392578 -8.109999656677246,-130.11199951171875 C-8.109999656677246,-130.11199951171875 -130.11300659179688,-8.109999656677246 -130.11300659179688,-8.109999656677246 C-134.5919952392578,-3.63100004196167 -134.5919952392578,3.631999969482422 -130.11300659179688,8.111000061035156 C-130.11300659179688,8.111000061035156 -8.109999656677246,130.11300659179688 -8.109999656677246,130.11300659179688 C-3.63100004196167,134.59300231933594 3.63100004196167,134.59300231933594 8.109999656677246,130.11300659179688 C8.109999656677246,130.11300659179688 130.11300659179688,8.111000061035156 130.11300659179688,8.111000061035156z"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "__lottie_element_99",
    "mask-type": "alpha"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "block"
    },
    transform: "matrix(7.806458950042725,7.806458950042725,-7.806458950042725,7.806458950042725,2236.77587890625,-6332.1552734375)",
    opacity: 1
  }, _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,426.4100036621094,548.8280029296875)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(21,31,109)",
    fillOpacity: 1,
    d: " M130.11300659179688,8.111000061035156 C134.5919952392578,3.631999969482422 134.5919952392578,-3.63100004196167 130.11300659179688,-8.109999656677246 C130.11300659179688,-8.109999656677246 8.109999656677246,-130.11199951171875 8.109999656677246,-130.11199951171875 C3.63100004196167,-134.5919952392578 -3.63100004196167,-134.5919952392578 -8.109999656677246,-130.11199951171875 C-8.109999656677246,-130.11199951171875 -130.11300659179688,-8.109999656677246 -130.11300659179688,-8.109999656677246 C-134.5919952392578,-3.63100004196167 -134.5919952392578,3.631999969482422 -130.11300659179688,8.111000061035156 C-130.11300659179688,8.111000061035156 -8.109999656677246,130.11300659179688 -8.109999656677246,130.11300659179688 C-3.63100004196167,134.59300231933594 3.63100004196167,134.59300231933594 8.109999656677246,130.11300659179688 C8.109999656677246,130.11300659179688 130.11300659179688,8.111000061035156 130.11300659179688,8.111000061035156z"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "__lottie_element_107",
    "mask-type": "alpha"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "block"
    },
    transform: "matrix(7.806458950042725,7.806458950042725,-7.806458950042725,7.806458950042725,2388.77587890625,-6332.1552734375)",
    opacity: 1
  }, _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,426.4100036621094,548.8280029296875)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(21,31,109)",
    fillOpacity: 1,
    d: " M130.11300659179688,8.111000061035156 C134.5919952392578,3.631999969482422 134.5919952392578,-3.63100004196167 130.11300659179688,-8.109999656677246 C130.11300659179688,-8.109999656677246 8.109999656677246,-130.11199951171875 8.109999656677246,-130.11199951171875 C3.63100004196167,-134.5919952392578 -3.63100004196167,-134.5919952392578 -8.109999656677246,-130.11199951171875 C-8.109999656677246,-130.11199951171875 -130.11300659179688,-8.109999656677246 -130.11300659179688,-8.109999656677246 C-134.5919952392578,-3.63100004196167 -134.5919952392578,3.631999969482422 -130.11300659179688,8.111000061035156 C-130.11300659179688,8.111000061035156 -8.109999656677246,130.11300659179688 -8.109999656677246,130.11300659179688 C-3.63100004196167,134.59300231933594 3.63100004196167,134.59300231933594 8.109999656677246,130.11300659179688 C8.109999656677246,130.11300659179688 130.11300659179688,8.111000061035156 130.11300659179688,8.111000061035156z"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "__lottie_element_111",
    "mask-type": "alpha"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "block"
    },
    transform: "matrix(7.806458950042725,7.806458950042725,-7.806458950042725,7.806458950042725,2236.77587890625,-6332.1552734375)",
    opacity: 1
  }, _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,426.4100036621094,548.8280029296875)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(21,31,109)",
    fillOpacity: 1,
    d: " M130.11300659179688,8.111000061035156 C134.5919952392578,3.631999969482422 134.5919952392578,-3.63100004196167 130.11300659179688,-8.109999656677246 C130.11300659179688,-8.109999656677246 8.109999656677246,-130.11199951171875 8.109999656677246,-130.11199951171875 C3.63100004196167,-134.5919952392578 -3.63100004196167,-134.5919952392578 -8.109999656677246,-130.11199951171875 C-8.109999656677246,-130.11199951171875 -130.11300659179688,-8.109999656677246 -130.11300659179688,-8.109999656677246 C-134.5919952392578,-3.63100004196167 -134.5919952392578,3.631999969482422 -130.11300659179688,8.111000061035156 C-130.11300659179688,8.111000061035156 -8.109999656677246,130.11300659179688 -8.109999656677246,130.11300659179688 C-3.63100004196167,134.59300231933594 3.63100004196167,134.59300231933594 8.109999656677246,130.11300659179688 C8.109999656677246,130.11300659179688 130.11300659179688,8.111000061035156 130.11300659179688,8.111000061035156z"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "__lottie_element_115",
    "mask-type": "alpha"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "block"
    },
    transform: "matrix(7.806458950042725,7.806458950042725,-7.806458950042725,7.806458950042725,2236.77587890625,-6332.1552734375)",
    opacity: 1
  }, _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,426.4100036621094,548.8280029296875)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(21,31,109)",
    fillOpacity: 1,
    d: " M130.11300659179688,8.111000061035156 C134.5919952392578,3.631999969482422 134.5919952392578,-3.63100004196167 130.11300659179688,-8.109999656677246 C130.11300659179688,-8.109999656677246 8.109999656677246,-130.11199951171875 8.109999656677246,-130.11199951171875 C3.63100004196167,-134.5919952392578 -3.63100004196167,-134.5919952392578 -8.109999656677246,-130.11199951171875 C-8.109999656677246,-130.11199951171875 -130.11300659179688,-8.109999656677246 -130.11300659179688,-8.109999656677246 C-134.5919952392578,-3.63100004196167 -134.5919952392578,3.631999969482422 -130.11300659179688,8.111000061035156 C-130.11300659179688,8.111000061035156 -8.109999656677246,130.11300659179688 -8.109999656677246,130.11300659179688 C-3.63100004196167,134.59300231933594 3.63100004196167,134.59300231933594 8.109999656677246,130.11300659179688 C8.109999656677246,130.11300659179688 130.11300659179688,8.111000061035156 130.11300659179688,8.111000061035156z"
  })))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#__lottie_element_2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.8301600217819214,0,0,1.8301600217819214,-502.95361328125,-725.2864379882812)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,695.8989868164062,539.1820068359375)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(21,31,109)",
    fillOpacity: 1,
    d: " M7.564000129699707,-52.367000579833984 C-9.019000053405762,-52.367000579833984 -22.983999252319336,-47.422000885009766 -34.03900146484375,-38.11199951171875 C-34.03900146484375,-38.11199951171875 -34.03900146484375,-108.22699737548828 -34.03900146484375,-108.22699737548828 C-34.03900146484375,-108.22699737548828 -82.6240005493164,-108.22699737548828 -82.6240005493164,-108.22699737548828 C-82.6240005493164,-108.22699737548828 -82.6240005493164,104.44499969482422 -82.6240005493164,104.44499969482422 C-82.6240005493164,104.44499969482422 -37.82099914550781,104.44499969482422 -37.82099914550781,104.44499969482422 C-37.82099914550781,104.44499969482422 -37.82099914550781,91.35199737548828 -37.82099914550781,91.35199737548828 C-26.764999389648438,102.11599731445312 -11.928000450134277,108.22699737548828 6.400000095367432,108.22699737548828 C50.91299819946289,108.22699737548828 82.625,73.89800262451172 82.625,27.93000030517578 C82.625,-18.03700065612793 51.7859992980957,-52.367000579833984 7.564000129699707,-52.367000579833984z M-0.5820000171661377,65.45999908447266 C-21.81999969482422,65.45999908447266 -36.36600112915039,50.04100036621094 -36.36600112915039,27.93000030517578 C-36.36600112915039,5.5279998779296875 -22.111000061035156,-9.890999794006348 -0.5820000171661377,-9.890999794006348 C19.783000946044922,-9.890999794006348 34.62099838256836,6.110000133514404 34.62099838256836,27.93000030517578 C34.62099838256836,49.75 19.783000946044922,65.45999908447266 -0.5820000171661377,65.45999908447266z"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,877.2899780273438,568.5659790039062)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(21,31,109)",
    fillOpacity: 1,
    d: " M37.965999603271484,-62.257999420166016 C27.202999114990234,-73.02300262451172 12.656000137329102,-78.84200286865234 -6.254000186920166,-78.84200286865234 C-50.766998291015625,-78.84200286865234 -82.7699966430664,-47.42100143432617 -82.7699966430664,-1.4539999961853027 C-82.7699966430664,44.513999938964844 -50.766998291015625,78.84300231933594 -6.254000186920166,78.84300231933594 C12.656000137329102,78.84300231933594 27.202999114990234,72.44300079345703 37.965999603271484,61.09600067138672 C37.965999603271484,61.09600067138672 37.965999603271484,75.06099700927734 37.965999603271484,75.06099700927734 C37.965999603271484,75.06099700927734 82.7699966430664,75.06099700927734 82.7699966430664,75.06099700927734 C82.7699966430664,75.06099700927734 82.7699966430664,-78.26000213623047 82.7699966430664,-78.26000213623047 C82.7699966430664,-78.26000213623047 37.965999603271484,-78.26000213623047 37.965999603271484,-78.26000213623047 C37.965999603271484,-78.26000213623047 37.965999603271484,-62.257999420166016 37.965999603271484,-62.257999420166016z M0.7279999852180481,36.07600021362305 C-19.92799949645996,36.07600021362305 -34.474998474121094,20.365999221801758 -34.474998474121094,-1.4539999961853027 C-34.474998474121094,-23.27400016784668 -19.63800048828125,-39.275001525878906 0.7279999852180481,-39.275001525878906 C21.96500015258789,-39.275001525878906 36.22100067138672,-23.856000900268555 36.22100067138672,-1.4539999961853027 C36.22100067138672,20.656999588012695 21.96500015258789,36.07600021362305 0.7279999852180481,36.07600021362305z"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,1016.3939819335938,537.2919921875)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(21,31,109)",
    fillOpacity: 1,
    d: " M-24.292999267578125,106.33599853515625 C-24.292999267578125,106.33599853515625 24.29199981689453,106.33599853515625 24.29199981689453,106.33599853515625 C24.29199981689453,106.33599853515625 24.29199981689453,-106.33599853515625 24.29199981689453,-106.33599853515625 C24.29199981689453,-106.33599853515625 -24.292999267578125,-106.33599853515625 -24.292999267578125,-106.33599853515625 C-24.292999267578125,-106.33599853515625 -24.292999267578125,106.33599853515625 -24.292999267578125,106.33599853515625z"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,1145.885986328125,567.1119995117188)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(21,31,109)",
    fillOpacity: 1,
    d: " M-0.14499999582767487,-80.2969970703125 C-49.02199935913086,-80.2969970703125 -83.93399810791016,-45.96799850463867 -83.93399810791016,0 C-83.93399810791016,45.67599868774414 -49.02199935913086,80.2969970703125 -0.14499999582767487,80.2969970703125 C49.02199935913086,80.2969970703125 83.93399810791016,45.67599868774414 83.93399810791016,0 C83.93399810791016,-45.96799850463867 49.02199935913086,-80.2969970703125 -0.14499999582767487,-80.2969970703125z M0.14499999582767487,37.23899841308594 C-21.093000411987305,37.23899841308594 -35.05699920654297,21.52899932861328 -35.05699920654297,0 C-35.05699920654297,-22.111000061035156 -21.093000411987305,-37.2400016784668 0.14499999582767487,-37.2400016784668 C21.384000778198242,-37.2400016784668 35.05699920654297,-22.111000061035156 35.05699920654297,-0.2919999957084656 C35.05699920654297,21.819000244140625 21.093000411987305,37.23899841308594 0.14499999582767487,37.23899841308594z"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,1275.2449951171875,439.8290100097656)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(21,31,109)",
    fillOpacity: 1,
    d: " M0.6700000166893005,-29.81999969482422 C-16.4950008392334,-29.81999969482422 -31.218000411987305,-17.309999465942383 -31.218000411987305,0.1459999978542328 C-31.218000411987305,17.601999282836914 -16.4950008392334,29.81999969482422 0.6700000166893005,29.81999969482422 C17.834999084472656,29.81999969482422 31.218000411987305,17.601999282836914 31.218000411987305,0.1459999978542328 C31.218000411987305,-17.309999465942383 17.834999084472656,-29.81999969482422 0.6700000166893005,-29.81999969482422z"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,1275.76904296875,566.9669799804688)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(21,31,109)",
    fillOpacity: 1,
    d: " M-24.292999267578125,76.66000366210938 C-24.292999267578125,76.66000366210938 24.292999267578125,76.66000366210938 24.292999267578125,76.66000366210938 C24.292999267578125,76.66000366210938 24.292999267578125,-76.66100311279297 24.292999267578125,-76.66100311279297 C24.292999267578125,-76.66100311279297 -24.292999267578125,-76.66100311279297 -24.292999267578125,-76.66100311279297 C-24.292999267578125,-76.66100311279297 -24.292999267578125,76.66000366210938 -24.292999267578125,76.66000366210938z"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,1387.0479736328125,567.1119995117188)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(21,31,109)",
    fillOpacity: 1,
    d: " M-12.800999641418457,-34.9109992980957 C-12.800999641418457,-41.31100082397461 -7.855999946594238,-45.09400177001953 2.0360000133514404,-45.09400177001953 C12.218000411987305,-45.09400177001953 19.492000579833984,-40.14899826049805 22.982999801635742,-30.548999786376953 C22.982999801635742,-30.548999786376953 63.13199996948242,-46.257999420166016 63.13199996948242,-46.257999420166016 C57.02199935913086,-67.78700256347656 34.33000183105469,-80.2969970703125 2.9089999198913574,-80.2969970703125 C-35.78499984741211,-80.2969970703125 -60.222999572753906,-62.25899887084961 -60.222999572753906,-32.58399963378906 C-60.222999572753906,20.075000762939453 19.783000946044922,8.435999870300293 19.783000946044922,32.58399963378906 C19.783000946044922,39.56700134277344 13.96399974822998,43.930999755859375 2.9089999198913574,43.930999755859375 C-12.800999641418457,43.930999755859375 -22.983999252319336,36.65800094604492 -27.05699920654297,23.85700035095215 C-27.05699920654297,23.85700035095215 -67.20500183105469,39.2760009765625 -67.20500183105469,39.2760009765625 C-58.1870002746582,66.04199981689453 -33.45800018310547,80.2969970703125 1.1629999876022339,80.2969970703125 C41.60300064086914,80.2969970703125 67.20500183105469,61.09700012207031 67.20500183105469,29.385000228881836 C67.20500183105469,-27.055999755859375 -12.800999641418457,-13.092000007629395 -12.800999641418457,-34.9109992980957z"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,1547.3470458984375,566.9660034179688)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(21,31,109)",
    fillOpacity: 1,
    d: " M79.71499633789062,-3.055000066757202 C79.71499633789062,-40.875999450683594 50.040000915527344,-80.44300079345703 -0.0010000000474974513,-80.44300079345703 C-44.22200012207031,-80.44300079345703 -79.71499633789062,-44.07600021362305 -79.71499633789062,0.14499999582767487 C-79.71499633789062,45.821998596191406 -47.7130012512207,80.44300079345703 2.9089999198913574,80.44300079345703 C36.319000244140625,80.44300079345703 56.04800033569336,67.56800079345703 67.875,52.891998291015625 C67.875,52.891998291015625 39.93899917602539,24.893999099731445 39.93899917602539,24.893999099731445 C31.215999603271484,35.689998626708984 21.527999877929688,40.875999450683594 4.363999843597412,40.875999450683594 C-13.96500015258789,40.875999450683594 -27.63800048828125,31.56599998474121 -32.584999084472656,14.401000022888184 C-32.584999084472656,14.401000022888184 78.5510025024414,14.401000022888184 78.5510025024414,14.401000022888184 C79.13300323486328,10.32800006866455 79.71499633789062,4.510000228881836 79.71499633789062,-3.055000066757202z M-33.16699981689453,-15.855999946594238 C-29.093000411987305,-34.47600173950195 -16.58300018310547,-44.07600021362305 1.1629999876022339,-44.07600021362305 C18.90999984741211,-44.07600021362305 30.54800033569336,-33.3120002746582 34.62099838256836,-15.855999946594238 C34.62099838256836,-15.855999946594238 -33.16699981689453,-15.855999946594238 -33.16699981689453,-15.855999946594238z"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#__lottie_element_4)",
    transform: "matrix(-0.11737971752882004,-0.11737972497940063,0.11737972497940063,-0.11737971752882004,278,578.4920654296875)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#__lottie_element_85)",
    transform: "matrix(1,0,0,1,4,-4)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#__lottie_element_88)",
    transform: "matrix(1,0,0,1,0,0)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "none"
    },
    transform: "matrix(0.6666000485420227,0,0,0.6666000485420227,1447.6385498046875,1236.992919921875)",
    opacity: 1
  }, _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,-251.48300170898438,64.51699829101562)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(21,31,109)",
    fillOpacity: 1,
    d: " M540,-540 C540,-540 540,540 540,540 C540,540 -540,540 -540,540 C-540,540 -540,-540 -540,-540 C-540,-540 540,-540 540,-540z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "none"
    },
    transform: "matrix(0.6665999889373779,0,0,0.6665999889373779,1447.6385498046875,516.9929809570312)",
    opacity: 1
  }, _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,-251.48300170898438,64.51699829101562)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(21,31,109)",
    fillOpacity: 1,
    d: " M540,-540 C540,-540 540,540 540,540 C540,540 -540,540 -540,540 C-540,540 -540,-540 -540,-540 C-540,-540 540,-540 540,-540z"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#__lottie_element_115)",
    style: {
      display: "block"
    }
  }, _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5400000214576721,0,0,0.5940000414848328,2277.59326171875,715.232666015625)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,-387.3949890136719,-327.3949890136719)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(21,31,109)",
    fillOpacity: 1,
    d: " M540,-540 C540,-540 540,540 540,540 C540,540 -540,540 -540,540 C-540,540 -540,-540 -540,-540 C-540,-540 540,-540 540,-540z"
  }))))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#__lottie_element_111)",
    style: {
      display: "none"
    }
  }, _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.6660000085830688,0,0,1.5687495470046997,2167.127685546875,1418.7889404296875)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,-251.48300170898438,64.51699829101562)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(21,31,109)",
    fillOpacity: 1,
    d: " M540,-540 C540,-540 540,540 540,540 C540,540 -540,540 -540,540 C-540,540 -540,-540 -540,-540 C-540,-540 540,-540 540,-540z"
  }))))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#__lottie_element_107)",
    style: {
      display: "block"
    }
  }, _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5940000414848328,0,0,0.8999999761581421,2269.3525390625,1574.655517578125)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,-387.3949890136719,-327.3949890136719)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(21,31,109)",
    fillOpacity: 1,
    d: " M540,-540 C540,-540 540,540 540,540 C540,540 -540,540 -540,540 C-540,540 -540,-540 -540,-540 C-540,-540 540,-540 540,-540z"
  }))))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "block"
    },
    transform: "matrix(0.5940000414848328,0,0,0.506600022315979,670.1409301757812,1000.8796997070312)",
    opacity: 1
  }, _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,-251.48300170898438,64.51699829101562)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(21,31,109)",
    fillOpacity: 1,
    d: " M540,-540 C540,-540 540,540 540,540 C540,540 -540,540 -540,540 C-540,540 -540,-540 -540,-540 C-540,-540 540,-540 540,-540z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "block"
    },
    transform: "matrix(0.8999999761581421,0,0,0.5940000414848328,1754.655517578125,2233.712646484375)",
    opacity: 1
  }, _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,-387.3949890136719,-327.3949890136719)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(21,31,109)",
    fillOpacity: 1,
    d: " M540,-540 C540,-540 540,540 540,540 C540,540 -540,540 -540,540 C-540,540 -540,-540 -540,-540 C-540,-540 540,-540 540,-540z"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#__lottie_element_99)",
    style: {
      display: "block"
    }
  }, _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.6666000485420227,0,0,0.5940000414848328,818.237548828125,2233.712646484375)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,-387.3949890136719,-327.3949890136719)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(21,31,109)",
    fillOpacity: 1,
    d: " M540,-540 C540,-540 540,540 540,540 C540,540 -540,540 -540,540 C-540,540 -540,-540 -540,-540 C-540,-540 540,-540 540,-540z"
  }))))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#__lottie_element_95)",
    style: {
      display: "block"
    }
  }, _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.5,0,0,0.5940000414848328,1591.092529296875,715.232666015625)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,-387.3949890136719,-327.3949890136719)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(21,31,109)",
    fillOpacity: 1,
    d: " M540,-540 C540,-540 540,540 540,540 C540,540 -540,540 -540,540 C-540,540 -540,-540 -540,-540 C-540,-540 540,-540 540,-540z"
  }))))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#__lottie_element_91)",
    style: {
      display: "block"
    }
  }, _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5412791967391968,0,0,0.6666000485420227,2277.398193359375,2218.277587890625)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,-387.3949890136719,-327.3949890136719)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(21,31,109)",
    fillOpacity: 1,
    d: " M540,-540 C540,-540 540,540 540,540 C540,540 -540,540 -540,540 C-540,540 -540,-540 -540,-540 C-540,-540 540,-540 540,-540z"
  }))))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#__lottie_element_46)",
    transform: "matrix(1,0,0,1,8,0)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#__lottie_element_49)",
    transform: "matrix(1,0,0,1,0,0)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "none"
    },
    transform: "matrix(0.6666000485420227,0,0,0.6666000485420227,1447.6385498046875,1236.992919921875)",
    opacity: 1
  }, _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,-251.48300170898438,64.51699829101562)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(21,31,109)",
    fillOpacity: 1,
    d: " M540,-540 C540,-540 540,540 540,540 C540,540 -540,540 -540,540 C-540,540 -540,-540 -540,-540 C-540,-540 540,-540 540,-540z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "none"
    },
    transform: "matrix(0.6665999889373779,0,0,0.6665999889373779,1447.6385498046875,516.9929809570312)",
    opacity: 1
  }, _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,-251.48300170898438,64.51699829101562)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(21,31,109)",
    fillOpacity: 1,
    d: " M540,-540 C540,-540 540,540 540,540 C540,540 -540,540 -540,540 C-540,540 -540,-540 -540,-540 C-540,-540 540,-540 540,-540z"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#__lottie_element_76)",
    style: {
      display: "block"
    }
  }, _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5400000214576721,0,0,0.5940000414848328,2277.59326171875,715.232666015625)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,-387.3949890136719,-327.3949890136719)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(21,31,109)",
    fillOpacity: 1,
    d: " M540,-540 C540,-540 540,540 540,540 C540,540 -540,540 -540,540 C-540,540 -540,-540 -540,-540 C-540,-540 540,-540 540,-540z"
  }))))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#__lottie_element_72)",
    style: {
      display: "none"
    }
  }, _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.6660000085830688,0,0,1.5687495470046997,2167.127685546875,1418.7889404296875)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,-251.48300170898438,64.51699829101562)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(21,31,109)",
    fillOpacity: 1,
    d: " M540,-540 C540,-540 540,540 540,540 C540,540 -540,540 -540,540 C-540,540 -540,-540 -540,-540 C-540,-540 540,-540 540,-540z"
  }))))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#__lottie_element_68)",
    style: {
      display: "block"
    }
  }, _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5940000414848328,0,0,0.8999999761581421,2269.3525390625,1574.655517578125)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,-387.3949890136719,-327.3949890136719)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(21,31,109)",
    fillOpacity: 1,
    d: " M540,-540 C540,-540 540,540 540,540 C540,540 -540,540 -540,540 C-540,540 -540,-540 -540,-540 C-540,-540 540,-540 540,-540z"
  }))))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "block"
    },
    transform: "matrix(0.5940000414848328,0,0,0.506600022315979,670.1409301757812,1000.8796997070312)",
    opacity: 1
  }, _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,-251.48300170898438,64.51699829101562)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(21,31,109)",
    fillOpacity: 1,
    d: " M540,-540 C540,-540 540,540 540,540 C540,540 -540,540 -540,540 C-540,540 -540,-540 -540,-540 C-540,-540 540,-540 540,-540z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "block"
    },
    transform: "matrix(0.8999999761581421,0,0,0.5940000414848328,1754.655517578125,2233.712646484375)",
    opacity: 1
  }, _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,-387.3949890136719,-327.3949890136719)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(21,31,109)",
    fillOpacity: 1,
    d: " M540,-540 C540,-540 540,540 540,540 C540,540 -540,540 -540,540 C-540,540 -540,-540 -540,-540 C-540,-540 540,-540 540,-540z"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#__lottie_element_60)",
    style: {
      display: "block"
    }
  }, _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.6666000485420227,0,0,0.5940000414848328,818.237548828125,2233.712646484375)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,-387.3949890136719,-327.3949890136719)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(21,31,109)",
    fillOpacity: 1,
    d: " M540,-540 C540,-540 540,540 540,540 C540,540 -540,540 -540,540 C-540,540 -540,-540 -540,-540 C-540,-540 540,-540 540,-540z"
  }))))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#__lottie_element_56)",
    style: {
      display: "block"
    }
  }, _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.5,0,0,0.5940000414848328,1591.092529296875,715.232666015625)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,-387.3949890136719,-327.3949890136719)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(21,31,109)",
    fillOpacity: 1,
    d: " M540,-540 C540,-540 540,540 540,540 C540,540 -540,540 -540,540 C-540,540 -540,-540 -540,-540 C-540,-540 540,-540 540,-540z"
  }))))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#__lottie_element_52)",
    style: {
      display: "block"
    }
  }, _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5412791967391968,0,0,0.6666000485420227,2277.398193359375,2218.277587890625)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,-387.3949890136719,-327.3949890136719)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(21,31,109)",
    fillOpacity: 1,
    d: " M540,-540 C540,-540 540,540 540,540 C540,540 -540,540 -540,540 C-540,540 -540,-540 -540,-540 C-540,-540 540,-540 540,-540z"
  }))))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#__lottie_element_7)",
    transform: "matrix(1,0,0,1,0,-8)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#__lottie_element_10)",
    transform: "matrix(1,0,0,1,0,0)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "none"
    },
    transform: "matrix(0.6666000485420227,0,0,0.6666000485420227,1447.6385498046875,1236.992919921875)",
    opacity: 1
  }, _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,-251.48300170898438,64.51699829101562)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(21,31,109)",
    fillOpacity: 1,
    d: " M540,-540 C540,-540 540,540 540,540 C540,540 -540,540 -540,540 C-540,540 -540,-540 -540,-540 C-540,-540 540,-540 540,-540z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "none"
    },
    transform: "matrix(0.6665999889373779,0,0,0.6665999889373779,1447.6385498046875,516.9929809570312)",
    opacity: 1
  }, _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,-251.48300170898438,64.51699829101562)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(21,31,109)",
    fillOpacity: 1,
    d: " M540,-540 C540,-540 540,540 540,540 C540,540 -540,540 -540,540 C-540,540 -540,-540 -540,-540 C-540,-540 540,-540 540,-540z"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#__lottie_element_37)",
    style: {
      display: "block"
    }
  }, _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5400000214576721,0,0,0.5940000414848328,2277.59326171875,715.232666015625)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,-387.3949890136719,-327.3949890136719)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(21,31,109)",
    fillOpacity: 1,
    d: " M540,-540 C540,-540 540,540 540,540 C540,540 -540,540 -540,540 C-540,540 -540,-540 -540,-540 C-540,-540 540,-540 540,-540z"
  }))))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#__lottie_element_33)",
    style: {
      display: "none"
    }
  }, _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.6660000085830688,0,0,1.5687495470046997,2167.127685546875,1418.7889404296875)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,-251.48300170898438,64.51699829101562)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(21,31,109)",
    fillOpacity: 1,
    d: " M540,-540 C540,-540 540,540 540,540 C540,540 -540,540 -540,540 C-540,540 -540,-540 -540,-540 C-540,-540 540,-540 540,-540z"
  }))))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#__lottie_element_29)",
    style: {
      display: "block"
    }
  }, _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5940000414848328,0,0,0.8999999761581421,2269.3525390625,1574.655517578125)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,-387.3949890136719,-327.3949890136719)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(21,31,109)",
    fillOpacity: 1,
    d: " M540,-540 C540,-540 540,540 540,540 C540,540 -540,540 -540,540 C-540,540 -540,-540 -540,-540 C-540,-540 540,-540 540,-540z"
  }))))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "block"
    },
    transform: "matrix(0.5940000414848328,0,0,0.506600022315979,670.1409301757812,1000.8796997070312)",
    opacity: 1
  }, _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,-251.48300170898438,64.51699829101562)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(21,31,109)",
    fillOpacity: 1,
    d: " M540,-540 C540,-540 540,540 540,540 C540,540 -540,540 -540,540 C-540,540 -540,-540 -540,-540 C-540,-540 540,-540 540,-540z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "block"
    },
    transform: "matrix(0.8999999761581421,0,0,0.5940000414848328,1754.655517578125,2233.712646484375)",
    opacity: 1
  }, _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,-387.3949890136719,-327.3949890136719)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(21,31,109)",
    fillOpacity: 1,
    d: " M540,-540 C540,-540 540,540 540,540 C540,540 -540,540 -540,540 C-540,540 -540,-540 -540,-540 C-540,-540 540,-540 540,-540z"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#__lottie_element_21)",
    style: {
      display: "block"
    }
  }, _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.6666000485420227,0,0,0.5940000414848328,818.237548828125,2233.712646484375)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,-387.3949890136719,-327.3949890136719)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(21,31,109)",
    fillOpacity: 1,
    d: " M540,-540 C540,-540 540,540 540,540 C540,540 -540,540 -540,540 C-540,540 -540,-540 -540,-540 C-540,-540 540,-540 540,-540z"
  }))))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#__lottie_element_17)",
    style: {
      display: "block"
    }
  }, _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.5,0,0,0.5940000414848328,1591.092529296875,715.232666015625)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,-387.3949890136719,-327.3949890136719)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(21,31,109)",
    fillOpacity: 1,
    d: " M540,-540 C540,-540 540,540 540,540 C540,540 -540,540 -540,540 C-540,540 -540,-540 -540,-540 C-540,-540 540,-540 540,-540z"
  }))))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#__lottie_element_13)",
    style: {
      display: "block"
    }
  }, _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5412791967391968,0,0,0.6666000485420227,2277.398193359375,2218.277587890625)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,-387.3949890136719,-327.3949890136719)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(21,31,109)",
    fillOpacity: 1,
    d: " M540,-540 C540,-540 540,540 540,540 C540,540 -540,540 -540,540 C-540,540 -540,-540 -540,-540 C-540,-540 540,-540 540,-540z"
  }))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaloise);
export default __webpack_public_path__ + "static/media/baloise.59aa7f8d3155e07229c72e928d57cf85.svg";
export { ForwardRef as ReactComponent };